// src/app/pages/view-templates/business-groups.resolver.ts
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom, filter, take } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

import { BuilderStore } from '../../builder/builder.store'; // only for buId signal
import { HttpContext } from '@angular/common/http';
import { WelodgeService } from '../../../services/welodge.service';
import { TokenService } from '../../../services/token.service';
import { SKIP_GLOBAL_LOADER } from '../../interceptors/loader.tokens';

export const businessGroupsResolver: ResolveFn<any[]> = async () => {
  const wl = inject(WelodgeService);
  const tokens = inject(TokenService);
  const store = inject(BuilderStore);

  // wait for buId to be set by the host/login flow
  const buId = await firstValueFrom(
    toObservable(store.buId).pipe(filter((x): x is number => !!x), take(1))
  );
  const token = tokens.getToken();
  if (!token) throw new Error('Missing token');
  const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
  const resp: any = await firstValueFrom(
    wl.getBusinessGroups(buId, context) // overload below
  );


  return resp?.BusinessUnit?.[0]?.BusinessGroup ?? [];
};
